import React from 'react';

const InputForm = ({ handleSubmit }) => {
  return (
    <div className='container-fluid form m-auto'>
      <form className='d-flex' onSubmit={(e) => handleSubmit(e)}>
        <input
          className='form-control me-2 shadow-none'
          type='search'
          placeholder='Try codechef, codeforces, leetcode, all, etc'
          aria-label='Search'
          required
        />
        <button className='btn btn-outline-success shadow-none' type='submit'>
          Search
        </button>
      </form>
    </div>
  );
};

export default InputForm;
